import React from 'react';

import cn from 'utils/cn';

import './index.css';

const cnSidebar = cn('sidebar-pusher');

interface ISidebarPusher {
    children: React.ReactChildren;
    pushed: boolean;
}

function SidebarPusher({ children, pushed }: ISidebarPusher) {
    const mod = pushed ? { pushed: 'yes' } : { pushed: 'no' };

    return (
        <div className={cnSidebar(mod)}>
            {children}
        </div>
    );
}

export default SidebarPusher;
